<template>
  <Row type="flex">
    <Col span="22"
         :class="!showAll?'hidden-all':''">
    <ul class="info_list"
        ref="ul">
      <li :class="index === selectIndex ? 'checked': ''"
          v-for="(item, index) in list"
          :key="index"
          @click="selectItem(index)">{{showName ? item[showName] : item}}
      </li>
    </ul>
    </Col>
    <Col class="more"
         span="2"
         v-if="showAllBtn">
    <span v-show="!showAll"
          @click="toggleShow">更多
      <Icon style="color:#999999;"
            type="ios-arrow-down" /> </span>
    <span class="primary"
          v-show="showAll"
          @click="toggleShow">收起
      <Icon style="color:#999999;"
            type="ios-arrow-up" /></span>
    </Col>
  </Row>
</template>

<script>
export default {
  name: 'index',
  props: {
    list: Array,
    showName: {
      type: String,
      default: null
    },
    defaultIndex: Number
  },
  model: {
    prop: 'list'
  },
  data() {
    return {
      selectIndex: 0,
      showAll: false,
      showAllBtn: false,
    }
  },
  watch: {
    list: {
      //监听的对象
      handler: function (value) {
        this.list = value
        this.selectIndex = this.defaultIndex ? this.defaultIndex : 0
        this.checkOrNoShowBtn()
      }
    }
  },
  mounted() {
    this.selectIndex = this.defaultIndex ? this.defaultIndex : 0
    this.checkOrNoShowBtn()
  },
  methods: {
    selectItem(index) {
      this.selectIndex = index
      this.$emit('change', index)
    },
    toggleShow() {
      this.showAll = !this.showAll
    },
    checkOrNoShowBtn() {
      this.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕
        const height = this.$refs.ul.offsetHeight
        if (height >= 54) {
          this.showAllBtn = true
          this.showAll = false
        } else {
          this.showAllBtn = false
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
@import "~@/my-theme/index.less";

.info_list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.hidden-all {
  max-height: 46px;
  overflow: hidden;
}

.info_list li {
  cursor: pointer;
  line-height: 24px;
  margin: 10px 15px;
  padding: 0 20px;
  border: 1px solid #fff;
  font-size: 12px;
}

.info_list .checked {
  border: 1px solid @primary-color;
  color: @primary-color;
}

.more {
  margin: 10px 0;
  line-height: 24px;
  cursor: pointer;

  span {
    font-size: 12px;
  }
}
</style>
